import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class ExcelExportService {
  constructor() {}

  exportToExcel(tableId: string, filename: string, excludeColumns: string[] = [], customDate: Date | null = null): void {
    // Use provided custom date, or default to today's date if no date is provided
    const today = customDate ? customDate : new Date();
    
    // Format the date in the format YYYY-MM-DD
    const formattedDate = today.toISOString().split('T')[0]; // "2025-03-20"

    // Combine the custom filename with today's date
    const fullFilename = `${filename}_${formattedDate}`;

    // Get the table element by id
    const table = document.getElementById(tableId) as HTMLTableElement;
    if (!table) {
      console.error('Table not found');
      return;
    }

    // Convert the table to a worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);

    // If there are columns to exclude, we remove them from the worksheet
    if (excludeColumns.length > 0) {
      excludeColumns.forEach((column) => {
        // Find the column index from the table headers
        const columnIndex = ws['!ref']?.split(':')[1]?.charAt(0);
        if (columnIndex) {
          // Remove the specific column by adjusting the range and sheet data
          for (let key in ws) {
            if (key.charAt(0) === columnIndex) {
              delete ws[key];
            }
          }
        }
      });
    }

    // Create a new workbook and append the worksheet
    const wb: XLSX.WorkBook = {
      Sheets: { 'Sheet1': ws },
      SheetNames: ['Sheet1'],
    };

    // Export the workbook to Excel
    const excelFile: Blob = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([excelFile]), `${fullFilename}.xlsx`);
  }
}
